module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightrain-aa5283393064a71fc8eea56d63daa109.png";